import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { trigger, state, transition, animate, style } from '@angular/animations';
import { CustomerFilterLanguage } from 'src/app/core/class/customer-filter-language';
import { EnterpriseTypes } from 'src/app/core/constants/enterprise-type';
import { CommonService } from 'src/app/core/services/common.service';
import { EnterpriseService } from '../../../core/services/enterprise.service';
import { BaseComponent } from '../../../shared/components/base/base.component';
import { Message } from '../../../core/class/message';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SCREEN_SIZE } from '../../../core/constants/screen-size';
import { AuthService } from '../../../core/auth/auth.service';
import { KycService } from '../../../core/services/kyc.service';
import { MatDialog } from '@angular/material';
import { ConfirmCancelComponent } from '../confirm-cancel/confirm-cancel.component';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable } from 'rxjs/Observable';
import { Subject, Subscription } from 'rxjs';
import { ToastrService } from "ngx-toastr";
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { AlertComponent } from 'src/app/shared/components/alert/alert.component';
import { AlertEkycComponent } from '../../../shared/components/alert-ekyc/alert-ekyc.component';
import { ConfirmIndentifyComponent } from '../confirm-indentify/confirm-indentify.component';
import { format } from 'date-fns';
import { error } from 'console';
import { RequestConfirmIdentityComponent } from 'src/app/shared/components/request-confirm-identity/request-confirm-identity.component';
import { EnterIdentityVneidComponent } from 'src/app/shared/components/enter-identity-vneid/enter-identity-vneid.component';
import { DocumentMohaService } from 'src/app/core/services/document-moha.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-kyc-confirm-account',
  templateUrl: './kyc-confirm-account.component.html',
  styleUrls: ['./kyc-confirm-account.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('void', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('*', style({ height: '*', visibility: 'visible' })),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class KycConfirmAccountReviewComponent extends BaseComponent implements OnInit, AfterViewInit {
  @ViewChildren('focus') focus;

  isAnonymous: boolean = false;
  personalId = EnterpriseTypes.PERSONAL;
  certificateType: any;
  certificate: any;
  type: any;
  representativeCertificateName: any;
  representativeCertificateType: any;
  representativeCertificate: any;
  enterpriseId: string;
  enterpriseType: [{
    id: number,
    name: '',
    langs: []
  }];
  addresses = {
    cityName: '',
    districtName: '',
    wardName: ''
  };
  defaultAddress = {
    cityId: null,
    districtId: null,
    wardId: 1,
    enterpriseId: null,
    address: '',
    isNewAddress: true
  };
  enterprisesDefaut = {
    id: null,
    name: '',
    enterpriseType: null,
    tenantId: 1,
    foreignName: '',
    parentId: null,
    abbreviation: '',
    taxCode: '',
    licenceDate: null,
    activeDate: null,
    phone: '',
    fax: '',
    primaryEmail: '',
    email: '',
    certificateId: null,
    certificateNo: '',
    issuedDate: null,
    issuedAt: '',
    expiryDate: null,
    accountNumber: '',
    bankName: '',
    bankBranch: '',
    representative: '',
    position: '',
    representativeCertificateId: null,
    representativeCertificateNo: '',
    representativeIssuedDate: null,
    representativeIssuedOn: '',
    representativeIssuedAt: '',
    status: true,
    birthday: null,
    sex: '',
    adminUser: '',
    businessType: null,
    addresses: [
      {
        address: '',
        cityId: null,
        districtId: null,
        wardId: null,
        id: null,
        isNewAddress: true
      }
    ],
    cityId: null,
    wardId: null,
    districtId: null,
    attachments: [],
    birthdayDisplay: '',
    representativeIssuedDateDisplay: '',
    issuedDateDisplay: ''
  };
  enterprises = this.enterprisesDefaut;
  oldData = this.enterprises;
  cities: { id: number, name: '', description: '' }[];
  districts: { id: number, cityId: number, name: '', description: '' }[];
  selectedDistricts: { id: number, cityId: number, name: '', description: '' }[];
  wards: { id: number, districtId: number, name: '', description: '' }[];
  selectWards: { id: number, districtId: number, name: '', description: '' }[];

  pdfSrc: string;
  zoomLevel = 100;
  widthRectangle = 300;
  heightRectangle = 136;
  pageCurrent = 1;
  imagePreviewHeight: number;
  imagePreviewWidth: number;
  public language: string;
  public isShowSidebarButton = true;
  public mediaBreakpoint: any;
  public SCREEN_SIZE = SCREEN_SIZE;
  checkAgree = false;
  checkCertificateType = false;
  checkPassport = false;
  private tenantId: string;
  private hashKey: string;
  public tempEnterprise: any;
  private contractIdAndContractEnterpriseIdEncode: string = null;

  // toggle webcam on/off
  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId: string;
  public videoOptions: MediaTrackConstraints = {
    width: { ideal: 0 },
    height: { ideal: 0 }
  };
  public errors: WebcamInitError[] = [];
  private trigger: Subject<void> = new Subject<void>();
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();
  typeVerify: string = '';
  subscription: Subscription;
  dataCheckVneid = {
    typeVerify: '',
    certificateNoCCCD: '',
    timeWaitShare: 60
  }
  constructor(public customerFilter: CustomerFilterLanguage,
    public commonService: CommonService,
    private enterpriseService: EnterpriseService,
    public message: Message,
    private router: Router,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private authSer: AuthService,
    private kycService: KycService,
    public dialog: MatDialog,
    private documentMohaService: DocumentMohaService,
    public deviceService: DeviceDetectorService,
    private toastr: ToastrService) {
    super(commonService, message);
    this.isAnonymous = this.router.url.includes('anonymous') && localStorage.getItem('isEnterpriseIdentify') == 'false';
    this.language = localStorage.getItem('__language') || 'vi';
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.isShowSidebarButton = false;
      this.zoomLevel = 50;
    }
  }

  ngOnInit() {
    this.subscription = this.route
      .queryParams
      .subscribe(params => {
        this.typeVerify = params.type;
      });
    this.route.paramMap.subscribe(params => {
      this.hashKey = params.get('hashKey');
      this.tenantId = params.get('tenantId');
      this.contractIdAndContractEnterpriseIdEncode = params.get('contractIdAndContractEnterpriseIdEncode') ? params.get('contractIdAndContractEnterpriseIdEncode') : null;
    });
    this.tempEnterprise = JSON.parse(localStorage.getItem('tempEnterprise'));
    this.enterpriseId = localStorage.getItem('enterpriseId');

    this.commonService.getCategory().subscribe(result => {
      this.cities = result[0].data;
      this.districts = result[1].data;
      this.wards = result[2].data;
      setTimeout(() => {
        this.loadData(this.enterpriseId);
      }, 1500);
    })
    window.scrollTo(0, 0);

    // WebcamUtil.getAvailableVideoInputs()
    //   .then((mediaDevices: MediaDeviceInfo[]) => {
    //     this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
    //   });
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focus.first.nativeElement.focus());
  }

  loadData(enterpriseId: string) {
    localStorage.setItem('SignDataValidateKyc', JSON.stringify(this.tempEnterprise));
    if (this.tempEnterprise != null) {
      const responseData = this.tempEnterprise;
      if (responseData.addresses == null || responseData.addresses.length === 0) {
        responseData.addresses = [this.defaultAddress];
      }
      this.enterprises = responseData;
      this.enterprises.birthdayDisplay = this.enterprises.birthday ? format(this.enterprises.birthday, 'DD/MM/YYYY') : '';
      this.enterprises.representativeIssuedDateDisplay = this.enterprises.representativeIssuedDate ? format(this.enterprises.representativeIssuedDate, 'DD/MM/YYYY') : '';
      this.enterprises.issuedDateDisplay = this.enterprises.issuedDate ? format(this.enterprises.issuedDate, 'DD/MM/YYYY') : '';
      this.enterprises.addresses[0].isNewAddress = !!responseData.addresses[0].isNewAddress;
      if (this.enterprises.addresses.length > 0) {
        const cityItem = (this.enterprises.addresses[0].cityId != null && this.cities) ? this.cities.find(x => x.id === this.enterprises.addresses[0].cityId) : undefined;
        const districtItem = (this.enterprises.addresses[0].districtId != null && this.districts) ? this.districts.find(x => x.id === this.enterprises.addresses[0].districtId) : undefined;
        const wardItem = (this.enterprises.addresses[0].wardId != null && this.wards) ? this.wards.find(x => x.id === this.enterprises.addresses[0].wardId) : undefined;
        this.addresses = {
          cityName: (cityItem !== undefined) ? cityItem.name : '',
          districtName: (districtItem !== undefined) ? districtItem.name : '',
          wardName: (wardItem !== undefined) ? wardItem.name : ''
        };
      } else {
        this.addresses = {
          cityName: '',
          districtName: '',
          wardName: ''
        };
      }

      this.getEnterpriseType();
      this.getCertificateType();
      this.getRepresentativeCertificateType();
      this.viewDocumentUpload();
    } else {
      this.enterprises = this.enterprisesDefaut;
    }
  }

  viewDocumentUpload() {
    this.kycService.verifyNewAccountGetPdf(this.enterprises).subscribe(res => {
      this.showPdf(res);
    });
  }


  showPdf(blob: any) {
    const file = this.blobToFile(blob, 'application/pdf');
    this.commonService.readFile(file, (pdfSrc) => {
      this.pdfSrc = pdfSrc;
    });
  }

  public blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    b.lastModifiedDate = new Date();
    b.name = fileName;

    // Cast to a File() type
    return theBlob as File;
  }

  /**
   * Get enterprise type list
   */
  getEnterpriseType() {
    this.commonService.getEnterpriseType().subscribe(rs => {
      if (rs && rs.data) {
        this.enterpriseType = rs.data;
        this.type = this.enterpriseType.find(x => x.id === this.enterprises.enterpriseType).langs;
      }
    });
  }

  getEnterpriseTypeOptions(options) {
    const data = this.customerFilter.filterOptionsData(options);
    if (data !== undefined && data !== null) {
      return data;
    }
    else {
      return '';
    }

  }

  /**
   * Get certificate list
   */
  getCertificateType() {
    this.commonService.getCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        this.certificateType = rs.data;
        if (this.enterprises.enterpriseType !== this.personalId) {
          this.certificate = this.certificateType.find(x => x.id === this.enterprises.certificateId).langs;
        }
      }
    });
  }

  /**
   * Get representative certificate list
   */
  getRepresentativeCertificateType() {
    this.commonService.getRepresentativeCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        this.representativeCertificateType = rs.data;
        this.commonService.getCertificateType().subscribe(rs2 => {
          if (rs2 && rs2.data) {
            // Concat list getCertificateType and getRepresentativeCertificateType
            this.representativeCertificateType = this.representativeCertificateType.concat(rs2.data);
            if (this.enterprises.enterpriseType === this.personalId) {
              this.representativeCertificate = this.representativeCertificateType.find(x => x.id === this.enterprises.certificateId);
              // check ẩn KYC với cá nhân có loại giấy tờ khác
              if (this.representativeCertificate.id === 30003) {
                this.checkCertificateType = true;
              }
            } else {
              // tslint:disable-next-line:max-line-length
              this.representativeCertificate = this.representativeCertificateType.find(x => x.id === this.enterprises.representativeCertificateId);
            }
            this.representativeCertificateName = this.representativeCertificate !== undefined ? this.representativeCertificate.langs : '';
            // check hộ chiếu
            if (this.representativeCertificate.id === 30001) {
              localStorage.setItem('isPassport', 'true');
            } else {
              localStorage.setItem('isPassport', '');
            }
          }
        });
      }
    });
  }

  onBack() {
    this.router.navigate([`identification-method/${this.hashKey}/${this.tenantId}/`]);
  }

  /**
   * Get cities list from local storage or api
   */
  loadCities() {
    // if (localStorage.getItem('cities') === null) {
    this.getCitiesRedis().subscribe(rs => {
      const data = rs.data;
      if (data != null && data.length > 0) {
        this.cities = data;
        localStorage.setItem(
          'cities',
          JSON.stringify(this.cities),
        );
      }
    });
    // } else {
    //   this.cities = JSON.parse(
    //     localStorage.getItem('cities')
    //   );
    // }
  }

  /**
   * Get districts list from local storage or api
   */
  loadDistricts() {
    // if (localStorage.getItem('districts') === null) {
    this.getDistrictsRedis().subscribe(rs => {
      const data = rs.data;
      if (data != null && data.length > 0) {
        this.districts = data;
        localStorage.setItem(
          'districts',
          JSON.stringify(this.districts),
        );
      }
    });
    // } else {
    //   this.districts = JSON.parse(
    //     localStorage.getItem('districts')
    //   );
    // }
  }

  /**
   * Get wards list from local storage or api
   */
  loadWards() {
    // if (localStorage.getItem('wards') === null) {
    this.getWardsRedis().subscribe(rs => {
      const data = rs.data;
      if (data != null && data.length > 0) {
        this.wards = data;
        localStorage.setItem(
          'wards',
          JSON.stringify(this.wards),
        );
      }
    });
    // } else {
    //   this.wards = JSON.parse(
    //     localStorage.getItem('wards')
    //   );
    // }
  }

  onBackClick() {
    const dialogRe = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.message.getMessage('messages.confirm_just_change_data')
    });
    dialogRe.afterClosed().subscribe(rs => {
      if (rs) {
        localStorage.removeItem('tempEnterprise');

        if (this.hashKey && this.tenantId) {
          if(this.contractIdAndContractEnterpriseIdEncode) {
            this.router.navigate([`/kyc-confirm-account-anonymous/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}`], {
              queryParams: {
                type: this.typeVerify
              }
            });
          }else{
            this.router.navigate([`/kyc-confirm-account-anonymous/${this.hashKey}/${this.tenantId}`], {
              queryParams: {
                type: this.typeVerify
              }
            });
          }
        } else {
          this.router.navigate(['/kyc-confirm-account'], {
            queryParams: {
              type: this.typeVerify
            }
          });
        }
      }
      dialogRe.close();
    });
  }

  onSign() {
    this.kycService.checkErrorVerifyAccountGetPdf().subscribe(res => {
      if (!res.success) {
        if(res.code){
          this.toastr.error(res.message);
          return;
        }       
      }
    });
    if (this.hashKey && this.tenantId) {
      if(this.contractIdAndContractEnterpriseIdEncode) {
        this.router.navigate([`/kyc-sign-anonymous/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}`], {
          queryParams: {
            type: this.typeVerify
          }
        });
      }else{
        this.router.navigate([`/kyc-sign-anonymous/${this.hashKey}/${this.tenantId}`], {
          queryParams: {
            type: this.typeVerify
          }
        });
      }
    } else {
      this.router.navigate(['/kyc-sign'], {
        queryParams: {
          type: this.typeVerify
        }
      });
    }
  }

  onClickBtnViewUpdate() {
    if(this.tenantId&&this.hashKey){
      if(this.contractIdAndContractEnterpriseIdEncode) {
        this.router.navigate([`/kyc-confirm-account-review/update-enterprise-review-anonymous/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}`], {
          queryParams: {
            type: this.typeVerify
          }
        });
      }else{
        this.router.navigate([`/kyc-confirm-account-review/update-enterprise-review-anonymous/${this.hashKey}/${this.tenantId}`], {
          queryParams: {
            type: this.typeVerify
          }
        });
      }
    }else{
      this.router.navigate(['/kyc-confirm-account-review/update-enterprise-review'], {
        queryParams: {
          type: this.typeVerify
        }
      });
    }
  }

  onKycCamera() {
    const message = this.commonService.format(this.message.getMessage('messages.ekyc_must_be_on_phone'));
    const dialogRe = this.dialog.open(AlertEkycComponent, {
      width: '600px',
      data: message,
    });
    dialogRe.afterClosed().subscribe((rs) => {
      if (rs) {
        console.log("close")
      }
    });
  }

  public cameraWasSwitched(deviceId: string): void {
    console.log('active device: ' + deviceId);
    // this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

  public triggerSnapshot(): void {
    if (this.errors && this.errors[0] && this.errors[0].message) {
      // TODO show popup
    }
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
  }

  handleImage(webcamImage: WebcamImage): void {
    console.log('received webcam image', webcamImage);
  }

  showModalAuthenVneid() {
    this.documentMohaService.getCheckVneidConfirm(null, true).subscribe(res => {
      if (res.success) {
        this.dataCheckVneid = res.data;
        switch (this.dataCheckVneid.typeVerify) {
          case 'SHARE_INFO': 
            this.openEnterIdentityVneid();
            break;
          case 'FACE_MATCH': 
            this.openEnterIdentityVneid();
            break;
          case 'VERIFIED': 
            this.continueJoinDashboard();
            break;
        }
      } else {
        this.toastr.error(res.message);
      }
    })
}

private openRequestConfirmIdentity(verificationData?: any): void {
  const dialogRef = this.dialog.open(RequestConfirmIdentityComponent, {
    width: this.deviceService.isMobile() ? '100%' : '640px',
    panelClass: 'scontract-overlay-dialog',
    disableClose: true,
    data: 'EKYC'
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result) {
      this.openEnterIdentityVneid();
    }
  });
}

private openEnterIdentityVneid(verificationData?: any): void {
  const dialogRef = this.dialog.open(EnterIdentityVneidComponent, {
    panelClass: 'sign-authentication',
    width: '1080px',
    maxWidth: '90vw',
    height: 'auto',
    disableClose: true,
    data: {
      documentId: null,
      dataCheckVneid: this.dataCheckVneid,
      isEkyc: true,
      tempEnterprise: JSON.parse(localStorage.getItem('tempEnterprise'))
    }
  });

  dialogRef.afterClosed().subscribe(result => {
    if (!result) {
      // this.openRequestConfirmIdentity();
      return;
    } else {
      this.continueJoinDashboard();
    }
  });
}

private continueJoinDashboard(): void {
  this.router.navigate([`/home-enterprise/analysis-report`]);
}

}
